export default __webpack_public_path__ + "static/media/farmlands_harvesting_c.1311f91b.mp4";